import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { MarathiEditProvider } from "@/context/MarathiEditContext";
import { NavProvider, useNav, matchRoute } from "@/context/NavContext";
import LoginPage from "@/pages/LoginPage";
import AuthCallback from "@/pages/AuthCallback";
import LegalFormApp from "@/pages/LegalFormApp";
import HomePage from "@/pages/HomePage";
import CriminalDocumentsPage from "@/pages/CriminalDocumentsPage";
import BailAffidavitPage from "@/pages/BailAffidavitPage";
import { Toaster } from "@/components/ui/sonner";

function Router() {
  const { route } = useNav();

  // Match order matters — most specific first
  if (matchRoute(route, "/criminal/bail-affidavit/:caseId")) return <BailAffidavitPage />;
  if (route === "/criminal/bail-affidavit") return <BailAffidavitPage />;
  if (route === "/criminal") return <CriminalDocumentsPage />;
  if (route === "/civil") return <LegalFormApp />;
  return <HomePage />;
}

function Gate() {
  const { user, loading } = useAuth();
  if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-50">
        <div className="text-sm text-stone-600 animate-pulse">Loading…</div>
      </div>
    );
  }
  if (!user) return <LoginPage />;
  return (
    <NavProvider>
      <Router />
    </NavProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <MarathiEditProvider>
        <div className="App">
          <Gate />
          <Toaster position="top-right" richColors />
        </div>
      </MarathiEditProvider>
    </AuthProvider>
  );
}

export default App;
